var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.86 107.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logonemesis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.44,107.55l-50.63-66v64.67H0V1.78H8.9l49.29,63v-63H76V107.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.13,18.23V42.66H155.6V58.4H121.13V89.67h47.29v16.45H102.61V1.78h66.6V18.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.13,106.19H270.18L259.36,49.93l-21,57.62h-6.63l-21-57.62-11.25,56.26H181.58l21-104.41h9.83L235,72.08l22.08-70.3h9.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.3,18.23V42.66h34.47V58.4H323.3V89.67h47.29v16.45H304.78V1.78h66.6V18.23Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388,100.35l6.84-16.59q11,7.69,21.58,7.69,16.31,0,16.31-11.39a16.12,16.12,0,0,0-3.85-10.19Q425.06,65,413.05,59t-16.16-9.9a26.36,26.36,0,0,1-6.41-9.22,30.23,30.23,0,0,1-2.25-11.83A25.87,25.87,0,0,1,397.1,8Q406,0,419.86,0,438,0,446.42,6.77l-5.62,16a34.86,34.86,0,0,0-20.59-7q-6.4,0-9.93,3.38a11.66,11.66,0,0,0-3.53,8.8q0,9,19.87,18.66,10.47,5.13,15.1,9.44a29,29,0,0,1,7.06,10,32.6,32.6,0,0,1,2.41,12.78,25.79,25.79,0,0,1-10,20.87q-10,8.19-26.82,8.19A47.68,47.68,0,0,1,388,100.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.18,106.12V1.78H491.7V106.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.69,100.35l6.84-16.59q11,7.69,21.58,7.69,16.3,0,16.31-11.39a16.12,16.12,0,0,0-3.85-10.19Q550.73,65,538.72,59t-16.16-9.9a26.36,26.36,0,0,1-6.41-9.22,30.23,30.23,0,0,1-2.25-11.83A25.87,25.87,0,0,1,522.77,8q8.87-8,22.75-8,18.09,0,26.57,6.77l-5.62,16a34.86,34.86,0,0,0-20.59-7q-6.4,0-9.93,3.38a11.62,11.62,0,0,0-3.53,8.8q0,9,19.87,18.66,10.47,5.13,15.1,9.44a28.88,28.88,0,0,1,7.05,10,32.42,32.42,0,0,1,2.42,12.78,25.79,25.79,0,0,1-10,20.87q-10,8.19-26.82,8.19A47.65,47.65,0,0,1,513.69,100.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c6d7c4356ab25c196da0816acec837a5.svg";
export { ForwardRef as ReactComponent };